import { useContext } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { MotobombaContext } from "../../contexts/contexMotobomba";
import { ModalAlert, ModalConfirmController } from "../../styles/modals";

export const ModalAlertasMotoBomba = ({ alertas }) => {
  const { modalAlertaMotobomba, setModalAlertaMotobomba } =
    useContext(MotobombaContext);
  return (
    <ModalAlert>
      <div className="conteiner">
        <IoCloseCircle
          className="closeBotao"
          onClick={() => setModalAlertaMotobomba(!modalAlertaMotobomba)}
        />
        <div className="headerModal">
          <span>Data</span>
          <span>Alerta</span>
          <span>Horário</span>
        </div>
        <ul>
          {alertas &&
            alertas.map((alerta) => {
              return (
                <li>
                  <span>{alerta.dia}</span>
                  <span>{alerta.alerta}</span>
                  <span>{alerta.hora.split(":").slice(0, 2).join(":")}</span>
                </li>
              );
            })}
        </ul>
      </div>
    </ModalAlert>
  );
};

export const ModalConfimacaoMotoBomba = ({ mensagem }) => {
  const {
    modalConfimetionMotobomba,
    setModalConfimationMotobomba,
    funtionControleSave,
    setFuntionConoleSave,
    motoBombaUpdate,
  } = useContext(MotobombaContext);

  const controlerMotobomba = () => {
    if (funtionControleSave[0] === "acionamento") {
      let dataUpdate = {
        manual: !funtionControleSave[1],
        automatico: funtionControleSave[1],
      };
      motoBombaUpdate(dataUpdate, funtionControleSave[2]);
    }
    if (funtionControleSave[0] === "painel") {
      let dataUpdate = {
        painel: !funtionControleSave[1],
      };
      motoBombaUpdate(dataUpdate, funtionControleSave[2]);
    }
    if (funtionControleSave[0] === "power") {
      let dataUpdate = {
        ignicao: !funtionControleSave[1],
      };
      motoBombaUpdate(dataUpdate, funtionControleSave[2]);
    }
    if (funtionControleSave[0] === "aceleracao") {
      let dataUpdate = {
        aceleracao: funtionControleSave[1],
      };
      motoBombaUpdate(dataUpdate, funtionControleSave[2]);
    }
  };

  return (
    <ModalConfirmController>
      <div className="deleteContact">
        <h2>{`Tem certeza de que deseja ${mensagem}`}</h2>
        <div>
          <button className="buttonYes" onClick={() => controlerMotobomba()}>
            Sim
          </button>
          <button onClick={() => setModalConfimationMotobomba(false)}>
            Não
          </button>
        </div>
      </div>
    </ModalConfirmController>
  );
};
